<template>
  <v-layout
      flex-child
      wrap
      style="height:100vh"
    >
      <v-flex xs10>
        <img v-if="!$vuetify.breakpoint.smAndDown"
        src="../../assets/logo.png"
        height="45px"
        @click="window.location.replace('https://www.smartpress.co')"
        style="position:absolute;left:30px;top:20px;margin-left:0px;cursor:pointer;  "
      >
        <div v-if="!$vuetify.breakpoint.smAndDown" style="width:300px;transform: translateX(40%) translateY(70%);">
          <span class="title">We emailed you a code</span><br/><br/>
          <span class="normal">{{signupUser.attributes.email}}</span><br/>
           
          
            <v-text-field
              id="codeInput"
              v-model="code"
              required
              autofocus
              placeholder="Enter Code"/>
         
          <v-btn
            type="submit" 
            variant="primary" 
            @click="confirmSignUp">Submit</v-btn>
          <v-btn 
            variant="primary" 
            @click="confirmResend"><span>{{message}}</span></v-btn>
          <v-alert/>
        </div>
       
    <div style="width:80%;margin:40px;" v-if="$vuetify.breakpoint.smAndDown">
      <img
        src="../../assets/logo.png"
        height="50px"
        style="margin-bottom:10px;"
        
      ></br><br/>
       <span class="title">We emailed you a code</span><br/><br/>
          <span class="normal">{{signupUser.attributes.email}}</span><br/>
           
          
            <v-text-field
              id="codeInput"
              v-model="code"
              required
              autofocus
              placeholder="Enter Code"/>
         
          <v-btn
            type="submit" 
            variant="primary" 
            @click="confirmSignUp">Submit</v-btn>
          <v-btn 
            variant="primary" 
            @click="confirmResend"><span>{{message}}</span></v-btn>
          <v-alert/>
</div>
  
    </v-flex>
    
     <v-flex style="background-color:#5764E4" v-if="!$vuetify.breakpoint.smAndDown"   xs2> 
          <img
          
          src="../../assets/Art/Smartpress-connect.svg"
          height="305px"
           
          style="position:absolute;right:100px;top:50vh;margin-left:0px;cursor:pointer; "
        >
      </v-flex>
  </v-layout>
</template>

<script>
import Vue from "vue"

import { mapGetters, mapState } from "vuex"
import router from "@/router"
import store from "@/store"

import Alert from "@/components/auth/Alert.vue"

Vue.component("v-alert", Alert)

export default {
  data() {
    return {
      username: "",
      code: "",
      message: "Resend code",
      firstAttempt: true
    }
  },
  computed: {
    ...mapGetters("auth", ["hasAuthenticationStatus"]),
    ...mapState({
      signupUser: state => state.auth.signupUser,
    }),
  },
  watch: {
    code: function  () {
      
      if (this.code.length > 5 && this.firstAttempt) {
        this.confirmSignUp()
        this.firstAttempt = false
      }
    }
  },
  methods: {
    async confirmSignUp() {
      await store.dispatch("auth/confirmSignUp", {
        username: this.signupUser.username.trim(),
        code: this.code.trim()
      })

      this.$cookies.set("newUserSignIn", 'true')

      if (!this.hasAuthenticationStatus) {
        router.push({name: 'signIn', params: { incomingUserType: this.$route.params.incomingUserType }})
      }
    },
    async confirmResend() {
      let self = this;
      await store.dispatch("auth/confirmResend", {
        username: this.signupUser.username
      }).then(function  () {
        self.message = 'Re sent'
      })
    }
  }
}
</script>


<style>
::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
}
</style>
